import React from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { FormHelperText } from '@mui/material';
import CustomTextField from '../forms/theme-elements/CustomTextField';

interface JsonInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  rows?: number;
  disabled?: boolean;
  placeholder?: string;
  sx?: SxProps<Theme>;
}

export const JsonInput: React.FC<JsonInputProps> = ({
  value,
  onChange,
  error,
  rows = 6,
  disabled = false,
  placeholder = '{\n  "key": "value"\n}',
  sx,
}) => {
  const theme = useTheme();

  return (
    <>
      <CustomTextField
        multiline
        rows={rows}
        fullWidth
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        disabled={disabled}
        error={Boolean(error)}
        placeholder={placeholder}
        sx={{
          '& .MuiInputBase-input': {
            fontFamily: 'monospace',
            fontSize: '13px',
            lineHeight: 1.5,
          },
          ...(error && {
            '& fieldset': {
              borderColor: `${theme.palette.error.main} !important`,
            },
          }),
          ...sx,
        }}
      />
      {error && (
        <FormHelperText error sx={{ mt: 0.5 }}>
          {error}
        </FormHelperText>
      )}
    </>
  );
};
